// Shared event-type options for the admin event modals (create/edit) and the
// customer-facing map filter. Labels are stored verbatim as the event's
// `eventType` string, so capitalization here is what shows up everywhere.
//
// Keep this list as the single source of truth — adding a category here makes
// it selectable when creating/editing an event AND available as a map filter.

export const EVENT_TYPE_OTHER = '__other__'

// `value` is persisted to the backend as `eventType`. The "Other" entry is a
// sentinel that reveals a free-text input instead of being stored directly.
export const EVENT_TYPE_OPTIONS = [
  { value: '', label: 'Select type (optional)' },
  { value: 'Fitting Clinic', label: 'Fitting Clinic' },
  { value: 'Saddle Fitting', label: 'Saddle Fitting' },
  { value: 'Demo Day', label: 'Demo Day' },
  { value: 'Show', label: 'Show' },
  { value: 'Camp', label: 'Camp' },
  { value: 'Rodeo', label: 'Rodeo' },
  { value: 'Barrel Racing', label: 'Barrel Racing' },
  { value: 'Team Roping', label: 'Team Roping' },
  { value: 'Calf Roping', label: 'Calf Roping' },
  { value: 'Reining', label: 'Reining' },
  { value: EVENT_TYPE_OTHER, label: 'Other' },
]

// Resolve the selected dropdown value into the string to persist as eventType.
// Returns null when nothing meaningful was chosen.
export function resolveEventType(eventTypeSelect, eventTypeOther) {
  if (!eventTypeSelect) return null
  if (eventTypeSelect === EVENT_TYPE_OTHER) {
    const t = (eventTypeOther || '').trim()
    return t || null
  }
  return eventTypeSelect
}
